import { isProd } from "./Profile"
import ReactGA, { EventArgs } from "react-ga"

export function pageView(path?: string) {
  if (isProd()) {
    ReactGA.pageview(path || window.location.pathname + window.location.search)
  }
}

export function GAEvent(args: EventArgs) {
  if (isProd()) {
    ReactGA.event(args)
  }
}

export function initialize(trackingCode: string) {
  if (isProd()) {
    ReactGA.initialize(trackingCode)
  }
}
